import CustomButton from 'components/Buttons/CustomButton'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { useSnackbar } from 'notistack'
// import {  verifyAttendance } from './reportAttendanceAction'
import { P } from 'components'
import { formatDateOnlyPMB, formatDateOnlyPMBV1 } from 'utils/formatDate'
import { toggleModalApproval } from './eventApprovalSlice'

const ModalApprovalEvent = ({ row, refetch }) => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { isOpenModal } = useSelector((s) => s.eventApproval)
  const toggle = () => dispatch(toggleModalApproval())
  const [loading, setLoading] = useState(false)

  const onSubmitEdit = async () => {
    //   setLoading(true)
    //   dispatch(
    //     verifyAttendance({
    //       ids: row?.map((e) => e?.id),
    //       status: 'VERIFIED',
    //     }),
    //   )
    //     .then((res) => {
    //       if (res?.error?.message) {
    //         throw res?.payload?.data?.message || res?.error?.message
    //       }
    //       toggle()
    //       refetch()
    //       enqueueSnackbar('Berhasil edit data absensi.', {
    //         variant: 'success',
    //       })
    //       setLoading(false)
    //     })
    //     .catch((err) => {
    //       enqueueSnackbar(err, {
    //         variant: 'error',
    //       })
    //       setLoading(false)
    //     })
  }

  return (
    <>
      <Modal
        centered
        isOpen={isOpenModal}
        toggle={toggle}
        size="md"
        data-testid="event-approval-modal"
      >
        <ModalBody className="d-flex flex-column justify-content-center pt-4">
          <P size="regular" className="mb-2">
            Apakah Anda yakin untuk mengkonfirmasi event ini?
          </P>
          <div className="mb-3">
            {row?.map((e, i) => {
              return (
                <P size="regular">
                  {i + 1}. {e?.title} - ({formatDateOnlyPMB(row?.startDate)}
                  {row?.endDate ? (
                    `- ${formatDateOnlyPMB(row?.endDate)}`
                  ) : (
                    <></>
                  )}
                  )
                </P>
              )
            })}
          </div>
          <div className="d-flex justify-content-between gap-2 mt-3">
            <CustomButton
              color="primary"
              size="sm"
              onClick={toggle}
              block
              disabled={loading}
              className="btn-cancel"
              testId="event-approval-modal-cancel-button"
            >
              Batal
            </CustomButton>
            <CustomButton
              color="primary"
              size="sm"
              onClick={onSubmitEdit}
              block
              disabled={loading}
              testId="event-approval-modal-submit-button"
            >
              Konfirmasi
            </CustomButton>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalApprovalEvent
